const AbstractItemRepository = require('@/lib/Items/AbstractItemRepository');
const ApiResolvers = require('@/lib/Api/ApiResolvers');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const ItemOption = require('@/lib/ItemOptions/ItemOption');

/**
 * @method find(id): Promise<ItemOption>
 */
class ItemOptionRepository extends AbstractItemRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param {ItemBarcodeRepository} itemBarcodeRepository
     * @param {ApiClient} apiClient
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        itemBarcodeRepository,
        apiClient,
    ) {
        super(dataStore, hydrator, syncStateManager, itemBarcodeRepository);

        this.apiClient = apiClient;
    }

    getEntityClass() {
        return ItemOption;
    }

    getEntityName() {
        return 'ItemOption';
    }

    getTableName() {
        return DataStoreNames.ITEM_OPTIONS;
    }

    loadFromApi(branchID = null) {
        return this.apiClient
            .request(
                'GET',
                'itemoptions',
                {
                    branchID, // Send the requested branchID to the API so it is used instead of any default.
                    resolve: [
                        ApiResolvers.ITEM_BARCODES,
                    ].join(','),
                }
            )
            .then(({ data }) => {
                return this.hydrateModelsFromApi(data, branchID);
            });
    }
}

module.exports = ItemOptionRepository;
